export enum ErrorTarget {
  PAY = 'PAY',
  NAVER = 'NAVER',
  NAVER_REAL_NAME = 'NAVER_REAL_NAME',
  NAVER_NOT_OVER_14_YEARS = 'NAVER_NOT_OVER_14_YEARS',
}
